export const RankingTranslations = {
  RANKING_TITLE: {
    es: 'Ranking de {{month}}',
    en: '{{month}} ranking',
    cat: 'Rànquing de {{month}}',
    eus: '{{month}} ranking',
    pt: 'Ranking de {{month}}'
  },
  RANKING_REMAINING_DAYS: {
    es: 'Quedan <b>{{days}} días</b> para decidir los ganadores',
    en: 'There are <b>{{days}} days</b> left to decide the winners',
    cat: 'Queden <b>{{days}} dies</b> per decidir els guanyadors',
    eus: 'Quedan <b>{{days}} días</b> para decidir los ganadores',
    pt: 'Quedam <b>{{days}} dias</b> para decidir os ganhadores'
  },
  RANKING_REMAINING_HOURS: {
    es: 'Quedan <b>{{hours}} horas</b> para decidir los ganadores',
    en: 'There are <b>{{hours}} hours</b> left to decide the winners',
    cat: 'Queden <b>{{hours}} hores</b> per decidir els guanyadors',
    eus: 'Quedan <b>{{hours}} horas</b> para decidir los ganadores',
    pt: 'Quedam <b>{{hours}} horas</b> para decidir os ganhadores'
  },
  RANKING_DATA_FROM: {
    es: 'Datos de {{month}} de {{year}}',
    en: 'Data from {{month}} of {{year}}',
    cat: 'Dades de {{month}} de {{year}}',
    eus: 'Datos de {{month}} de {{year}}',
    pt: 'Dados de {{month}} de {{year}}'
  },
  HOW_DO_RANKING_WORK: {
    es: '¿Cómo funciona el ranking?',
    en: 'How does the ranking work?',
    cat: 'Com funciona el rànquing?',
    eus: '¿Cómo funciona el ranking?',
    pt: 'Como funciona o ranking?'
  },
  HOW_DOES_IT_WORK: {
    es: '¿Cómo funciona?',
    en: 'How does it work?',
    cat: 'Com funciona?',
    eus: '¿Cómo funciona?',
    pt: 'Como funciona?'
  },
  RANKING_SUBTITLE_1: {
    es: '¿De qué depende tu posición en el ranking?',
    en: 'What determines your position in the ranking?',
    cat: 'Quina determina la teva posició en el rànquing?',
    eus: '¿De qué depende tu posición en el ranking?',
    pt: 'O que determina a sua posição no ranking?'
  },
  RANKING_EXPLANATION_1: {
    es: 'Tu posición en el ranking del curso depende de los puntos que sumes durante el mes.',
    en: 'Your position in the course ranking depends on the points you earn during the month.',
    cat: 'La teva posició en el rànquing del curs depèn dels punts que guanyis durant el mes.',
    eus: 'Zure azkenekoaren ranking-posizioa hurrengo urtean eskaintzen dituen puntuak zehazten ditu.',
    pt: 'A sua posição no ranking do curso depende dos pontos que ganha durante o mês.'
  },
  RANKING_SUBTITLE_2: {
    es: '¿Cómo puedes sumar puntos?',
    en: 'How can you earn points?',
    cat: 'Com podeu guanyar punts?',
    eus: '¿Cómo puedes sumar puntos?',
    pt: 'Como pode ganhar pontos?'
  },
  RANKING_EXPLANATION_2_1: {
    es: '✅ Completado tu perfil.',
    en: '✅ Completed your profile.',
    cat: '✅ Completat el teu perfil.',
    eus: '✅ Zure perfil zabaldu duzu.',
    pt: '✅ Completou o seu perfil.'
  },
  RANKING_EXPLANATION_2_2: {
    es: '✅ Completando una lección del curso.',
    en: '✅ Completing a lesson of the course.',
    cat: '✅ Completant una lliçó del curs.',
    eus: '✅ Ikastarako azkenekoaren ranking-posizioa hurrengo urtean eskaintzen dituen puntuak zehazten ditu.',
    pt: '✅ A sua posição no ranking do curso depende dos pontos que ganha durante o mês.'
  },
  RANKING_EXPLANATION_2_3: {
    es: '✅ Terminando un tema del curso.',
    en: '✅ Finishing a topic of the course.',
    cat: '✅ Finalitzant un tema del curs.',
    eus: '✅ Ikastarako azkenekoaren ranking-posizioa hurrengo urtean eskaintzen dituen puntuak zehazten ditu.',
    pt: '✅ A sua posição no ranking do curso depende dos pontos que ganha durante o mês.'
  },
  RANKING_EXPLANATION_2_4: {
    es: '✅ Apuntándote a una clase en directo.',
    en: '✅ Attending a live class.',
    cat: '✅ Assistir a una classe en directe.',
    eus: '✅ Zuzeneko klase bat erreproduzitu duzu.',
    pt: '✅ Assistir a uma classe em direto.'
  },
  RANKING_EXPLANATION_2_5: {
    es: '✅ Completando un test con resultado positivo.',
    en: '✅ Completing a test with a positive result.',
    cat: '✅ Completant un test amb un resultat positiu.',
    eus: '✅ Ikastarako azkenekoaren ranking-posizioa hurrengo urtean eskaintzen dituen puntuak zehazten ditu.',
    pt: '✅ A sua posição no ranking do curso depende dos pontos que ganha durante o mês.'
  },
  RANKING_EXPLANATION_2_6: {
    es: '✅ Dándole like a los comentarios en las lecciones.',
    en: '✅ Giving a like to the comments in the lessons.',
    cat: '✅ Donar un like a los comentaris en les lliçons.',
    eus: '✅ Ikaslearen iruzkinak irakasleek egin dituzten iruzkinak like bat eman dituzu.',
    pt: '✅ Dar um like aos comentários nas lições.'
  },
  RANKING_SUBTITLE_3: {
    es: '¿Cada cuánto se actualiza?',
    en: 'How often is the ranking updated?',
    cat: 'Cada quant es actualitza el rànquing?',
    eus: 'Kontuak hirukoitze datorrenetan.',
    pt: 'A cada quanto é atualizado o ranking?'
  },
  RANKING_EXPLANATION_3_1: {
    es: 'Los puntos se reinician cada mes.',
    en: 'The points are reset every month.',
    cat: 'Els punts es reinicien cada mes.',
    eus: 'Puntuak hirukoitze datorrenetan.',
    pt: 'Os pontos são reiniciados cada mês.'
  },
  RANKING_EXPLANATION_3_2: {
    es: 'El ranking se actualiza una vez al día, ¡así que cada esfuerzo cuenta!',
    en: 'The ranking is updated once a day, so every effort counts!',
    cat: 'El rànquing s’actualitza un cop al dia.',
    eus: 'El ranking se actualiza una vez al día, beraz, edozein eginbide daiteke.',
    pt: 'O ranking é atualizado uma vez por dia, então cada esforço conta!'
  },
  GET_POINTS_TO_ENTER_RANKING: {
    es: 'Consigue {{points}}⚡ para entrar al ranking mensual',
    en: 'Get {{points}}⚡ to enter the monthly ranking',
    cat: 'Aconsegueix {{points}}⚡ per entrar al rànquing mensual',
    eus: 'Consigue {{points}}⚡ para entrar al ranking mensual',
    pt: 'Consiga {{points}}⚡ para entrar no ranking mensal'
  },
  STUDY_AND_GET_POINTS: {
    es: 'Estudiar y conseguir puntos',
    en: 'Study and get points',
    cat: 'Estudiar i aconseguir punts',
    eus: 'Estudiar y conseguir puntos',
    pt: 'Estudar e conseguir pontos'
  },
  PREPARING_RANKING_1: {
    es: 'Estamos preparando el ranking de este mes.',
    en: 'We are preparing this month’s ranking.',
    cat: 'Estem preparant el rànquing d’aquest mes.',
    eus: 'Estamos preparando el ranking de este mes.',
    pt: 'Estamos a preparar o ranking deste mês.'
  },
  PREPARING_RANKING_2: {
    es: 'El día {{day}} lo publicaremos.',
    en: 'We will publish it on {{day}}.',
    cat: 'El dia {{day}} el publicarem.',
    eus: 'El día {{day}} lo publicaremos.',
    pt: 'O dia {{day}} publicaremos.'
  },
  WE_ARE_RECOLLECTING_DATA: {
    es: 'Estamos recolectando datos',
    en: 'We are collecting the data',
    cat: 'Estem recopilant les dades',
    eus: 'Estamos recopilando los datos',
    pt: 'Estamos a recolher os dados'
  },
  WE_WILL_PUBLISH_RANKING_ON: {
    es: 'Publicaremos el ranking el día 5 del mes',
    en: 'We will publish the ranking on the 5th of the month',
    cat: 'Publicarem el rànquing el dia 5 del mes',
    eus: 'Publicaremos el ranking el día 5 del mes',
    pt: 'Publicaremos o ranking no dia 5 do mês'
  }
};
